<template>
  <div class="rooms_box">
    <div class="loading" v-if="isLoading"><img src="../../assets/images/loading.gif" alt=""></div>
    <div class="items" v-else>
      <div class="item" v-for="item in roomList" :key="item.id" @click="getLink(item)">
        <div class="top">
          <img :src="item.thumbnailUrl" alt="">
          <div class="lefttop" v-if="item.company.length > 1">
            <img v-if="item.company.length === 2" src="../../assets/images/two.png" alt="">
            <img v-if="item.company.length === 3" src="../../assets/images/three.png" alt="">
            <img v-if="item.company.length === 4" src="../../assets/images/four.png" alt="">
            <img v-if="item.company.length > 4" src="../../assets/images/five.png" alt="">
            <div :class="item.company.length > 4 ? 'lefttop_word lefttop_wordlong' : 'lefttop_word'">{{item.company}}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="name">{{item.title}}</div>
          <div class="time">{{getDate(item.startTime, item.endTime)}} {{getTime(item.startTime, item.endTime)}}</div>
          <!-- <div class="tabs">
            <div class="tab">标签1</div>
            <div class="tab">标签2</div>
            <div class="tab">标签3</div>
          </div> -->
          <div class="playbutton">
            <div v-if="item.status === 0" class="begin">即将开始</div>
            <div v-if="item.status === -1" class="replay">已结束</div>
            <div v-if="item.status === 1" class="play">正在直播</div>
          </div>
          <div class="intro" v-if="item.description">公司简介：<br>{{item.description}}</div>
        </div>
        <!-- <div class="showHide">﹀</div> -->
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "rooms.less";
</style>
<script>
import ModalApi from '../../components/ModalApi'
export default {
  mixins: [ModalApi],
  data () {
    return {
      roomList: [],
      isLoading: true
    }
  },
  created () {
    this.getRoomList()
  },
  methods: {
    getRoomList: function () {
      let self = this
      self.$http.get('https://goapi.gmic.cn/api/v1/room/brand_rooms').then(function (res) {
        // console.log('rooms')
        console.log(res)
        if (res.data.code === 200) {
          self.roomList = res.data.data
          self.isLoading = false
        }
      }).catch(function (err) {
        self.isLoading = true
        console.log(err)
      })
    },
    getDate: function (begin, end) {
      let begindate = begin.substring(0, 10)
      let enddate = end.substring(0, 10)
      let date = ''
      if (begindate === enddate) {
        date = begindate
      } else {
        date = begindate + '-' + enddate
      }
      return date
    },
    getTime: function (begin, end) {
      let time = begin.substring(11, 16) + '-' + end.substring(11, 16)
      return time
    },
    getLink: function (item) {
      let self = this
      if (item.status === 0) {
        self.alert(self.$t('lang.unstart'), self.$t('lang.ts'), self.$t('lang.qr'))
        return
      }
      if (item.status === -1) {
        self.alert(self.$t('lang.end'), self.$t('lang.ts'), self.$t('lang.qr'))
        return
      }
      if (item.status === 1) {
        window.location.href = item.streamMuduUrl
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/rooms/rooms.vue